import { Address } from '../common/address';
import { ListItem } from '../common/list-item';
import { ListSortBy } from '../common/list-sort-by';
import { ListGroupBy } from '../common/list-group-by';
import { MapMarker } from '../map/map-marker';
import { LatLng } from '../map/lat-lng';
import { DEFAULT_LAT } from '../map/default-lat';
import { DEFAULT_LNG } from '../map/default-lng';

/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
export class Location implements ListItem, MapMarker {
    public static readonly entityType: string = 'location';
    public id: string;
    public company_id?: string;
    public name?: string;
    public phone?: string;
    public email?: string;
    public avatar_url?: string;
    public updated_at?: any;
    public address?: Address;
    public as_manager?: boolean;
    public manage_payroll?: boolean;
    public timezone: string;
    public selected: boolean;
    public loading: boolean = false;

    /**
     * Validates if this item matches the filter.
     * @param filterBy
     * @param filterValue
     * @returns {boolean}
     */
    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        let isMatching: boolean = true;

        switch (filterBy) {
            default:
                isMatching = true;
                break;
        }

        return isMatching;
    }

    /**
     * Validates if this item matches the selected groups.
     * @param groupBy
     * @param selectedGroups
     * @returns {boolean}
     */
    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        return true;
    }

    /**
     * Custom valueOf allows for param based sort / comparision
     * @param ref
     * @returns {any}
     */
    valueOf(ref?: any): any {
        let res: any = this;
        if (ref === ListSortBy.NAME && this.name) {
            // location name sorting
            res = this.name.toLowerCase();
        }

        return res;
    }

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        let group: string = '';

        return group;
    }

    get tooltip(): string {
        return this.name;
    }

    get latLng(): LatLng {
        let response: LatLng;
        if (this.address && this.address.lat) {
            response = {
                lat: this.address.lat,
                lng: this.address.lng,
            };
        } else {
            response = {
                lat: DEFAULT_LAT,
                lng: DEFAULT_LNG,
            };
        }
        return response;
    }
}
